import { paths } from "src/routes/paths";

// ----------------------------------------------------------------------

export const SHIPMENT_STATUS = {
    DRAFT: {
        display: "Buy Label",
        color: "info"
    },
    PURCHASED: {
        display: "View Details",
        color: "primary"
    },
    EXPIRED: {
        display: "View Details",
        color: "primary"
    },
    EXPIRE_FAILED: {
        display: "View Details",
        color: "primary"
    },
    REFUNDED: {
        display: "Refund",
        color: "primary"
    },
    REQUESTED: {
        display: "Requested",
        color: "primary"
    },
    REFUND_PENDING: {
        display: "Refund Pending",
        color: "error"
    },
    REFUND_REJECTED: {
        display: "Refund Rejected",
        color: "error"
    },
    ERROR: {
        display: "Error",
        color: "error"
    }
};

export const SHIPMENT_TRACKING_STATUS = {
    CREATED: {
        display: "Label Created",
        color: "warning.main"
    },
    PRE_TRANSIT: {
        display: "Label Created",
        color: "warning.main"
    },
    IN_TRANSIT: {
        display: "In Transit",
        color: "info.main"
    },
    OUT_FOR_DELIVERY: {
        display: "Out for Delivery",
        color: "secondary.main"
    },
    DELIVERED: {
        display: "Delivered / Pickup Ready",
        color: "success.main"
    },
    AVAILABLE_FOR_PICKUP: {
        display: "Delivered / Pickup Ready",
        color: "success.main"
    },
    RETURN_TO_SENDER: {
        display: "Unsuccessful",
        color: "error.main"
    },
    FAILURE: {
        display: "Unsuccessful",
        color: "error.main"
    },
    VOIDED: {
        display: "Unsuccessful",
        color: "error.main"
    },
    ERROR: {
        display: "Unsuccessful",
        color: "error.main"
    },
    FAILED: {
        display: "Unsuccessful",
        color: "error.main"
    },
    CANCELLED: {
        display: "Unsuccessful",
        color: "error.main"
    },
    UNKNOWN: {
        display: "Unknown",
        color: "text.primary"
    }
};

// ----------------------------------

export const CARRIER = {
    UPS: {
        color: "#330000",
        icon: "ic_ups",
        tracking_url: "https://www.ups.com/track?trackingNumber="
    },
    UPS_CANADA: {
        color: "#330000",
        icon: "ic_ups",
        tracking_url: "https://www.ups.com/track?loc=en_CA&trackingNumber="
    },
    USPS: {
        color: "#304c9c",
        icon: "ic_usps",
        tracking_url: "https://tools.usps.com/go/TrackConfirmAction_input?strOrigTrackNum="
    },
    DHL_EXPRESS: {
        color: "#FECB00",
        icon: "ic_dhl_express",
        tracking_url: "http://www.dhl.com/en/express/tracking.html?brand=DHL&AWB="
    },
    DHL_ECOMMERCE: {
        color: "#FECB00",
        icon: "ic_dhl_ecommerce",
        tracking_url: "http://www.dhl.com/en/express/tracking.html?brand=DHL&AWB="
    },
    ONTRAC: {
        color: "#121212",
        icon: "ic_ontrac",
        tracking_url: "https://www.ontrac.com/trackingresults.asp?tracking_number="
    },
    FEDEX: {
        color: "#411A7F",
        icon: "ic_fedex",
        tracking_url: "https://www.fedex.com/fedextrack/system-error?trknbr="
    },
    GOFO_EXPRESS: {
        color: "#FF4800",
        icon: "ic_gofo_express",
        tracking_url: "https://www.gofoexpress.com/tracking.html"
    },
    SWIFTX: {
        color: "#5E51D3",
        icon: "ic_swiftx_express",
        tracking_url: "https://swiftx-express.com/track?trackingNumber="
    }
};

// ----------------------------------

export const TASK_TYPE = {
    EXPORT: {
        display: "Export",
        icon: "/assets/icon/navbar/ic_export.svg"
    },
    ORDER_SYNC: {
        display: "Sync Order",
        source: "Order",
        icon: "/assets/icon/navbar/ic_sync.svg"
    },
    ORDER_IMPORT: {
        display: "Import",
        source: "Order",
        icon: "/assets/icon/navbar/ic_import.svg"
    },
    BATCH_DOWNLOAD_PACKING_SLIP: {
        display: "Download Packing Slip",
        source: "Order",
        icon: "/assets/icon/navbar/ic_export.svg"
    },
    TRANSACTION_RECORD_EXPORT: {
        display: "Export",
        source: "Account - Transaction History",
        icon: "/assets/icon/navbar/ic_export.svg"
    },
    SHIPMENT_RECORD_EXPORT: {
        display: "Export",
        source: "Shipments",
        icon: "/assets/icon/navbar/ic_export.svg"
    },
    SHIPMENT_BILLING_EXPORT: {
        display: "Export",
        source: "Shipments",
        icon: "/assets/icon/navbar/ic_export.svg"
    },
    APPLY_SHIPPING_RULE: {
        display: "Apply Rules",
        source: "Setting - Shipping Rule",
        icon: "/assets/icon/navbar/ic_rule.svg"
    }
};

// ----------------------------------

export const TASK_SOURCE = {
    SHIPMENT_API: "Shipments"
};

// ----------------------------------

export const TRANSACTION_TYPE = {
    REWARD: {
        display: "Reward",
        color: "secondary.main"
    },
    LABEL: {
        display: "Label",
        color: "info.main"
    },
    PAYMENT: {
        display: "Payment",
        color: "success.main"
    },
    RECHARGE: {
        display: "Recharge",
        color: "warning.main"
    },
    CREDIT: {
        display: "Credit",
        color: "secondary.main"
    },
    CARRIER_ADJUSTMENT: {
        display: "Carrier Adjustment",
        color: "secondary.main"
    },
    SHIPMENT_ADJUSTMENT: {
        display: "Shipment Adjustment",
        color: "secondary.main"
    },
    PROMO_CREDIT: {
        display: "Promo Credit",
        color: "secondary.main"
    },
    ROLLBACK: {
        display: "Rollback",
        color: "error.main"
    },
    REFUND: {
        display: "Refund",
        color: "error.main"
    },
    VOID_FEE: {
        display: "Void Fee",
        color: "error.main"
    },
    SUBSCRIPTION: {
        display: "Subscription",
        color: "info.main"
    },
    PICKUP: {
        display: "Pickup",
        color: "success.main"
    },
    SERVICE_FEE: {
        display: "Service Fee",
        color: "success.main"
    },
    VOID_REVERSAL: {
        display: "Void Reversal",
        color: "secondary.main"
    }
};

// ----------------------------------

export const NOTIFICATION_TYPE = {
    SYSTEM: {
        icon: "/assets/icon/navbar/ic_system_notice.svg"
    },
    CARRIERS: {
        icon: "/assets/icon/navbar/ic_carriers_news.svg"
    }
};
